import React from 'react'
import styles from './LogosCarousel.module.scss'
import { Image } from '../Image/Image'
import ChargersFootball from '../../images/Chargers-Football-Logo.png'
import DPCC from '../../images/DPCC Primary Logo.png'
import FestivalOfWhales from '../../images/Festival Of Whales.png'
import FoundationBuilder from '../../images/Foundation Builder Badge 1.png'
import DanaPointFilmFest from '../../images/Logo-Dana-Point-Film-Fest-v7.png'
import DanaHillsHighSchool from '../../images/Logo-DanaHillsHighSchool.png'
import GreatParkIce from '../../images/Great-Park-Ice-Logo.png'
import Powerstone from '../../images/Powerstone-Logo.png'
import TustinGirlsSoftBall from '../../images/Logo-TustinGirlsSoftball.svg'
import TustinParksAndRecreation from '../../images/Parks and Recreation Logo with Tagline.png'
import RedoMarket from '../../images/Redo-Market-LOGO_Black.png'
import SunsetMarket from '../../images/Sunset Market Logo Black & White.png'
import THFootball from '../../images/TH-Football-Logo.png'
import TustinDinoDash from '../../images/Tustin Dino Dash Logo.png'
import TustinPonyBaseball from '../../images/Tustin Pony Baseball Logo.svg'
import TustinFootball from '../../images/Tustin Football Logo.jpg'
import OCSC from '../../images/oc-soccer-club-logo.svg'
import OCRiptide from '../../images/OC-Riptide-Logo.png'

type LogoData = {
  source: string
  title: string
}

export const LogosCarousel = (): React.JSX.Element => {
  const logos: LogoData[] = [
    {
      source: OCSC,
      title: 'Orange County Soccer Club',
    },
    {
      source: DPCC,
      title: 'Dana Point Chamber of Commerce',
    },
    {
      source: TustinFootball,
      title: 'Tustin Football',
    },
    {
      source: FestivalOfWhales,
      title: 'Festival Of Whales',
    },
    {
      source: FoundationBuilder,
      title: 'Ocean Institute ',
    },
    {
      source: DanaPointFilmFest,
      title: 'Dana Point Film Festival',
    },
    {
      source: DanaHillsHighSchool,
      title: 'Dana Hills High School',
    },
    {
      source: TustinGirlsSoftBall,
      title: 'Tustin Girls Soft Ball',
    },
    {
      source: TustinParksAndRecreation,
      title: 'Tustin Parks and Recreation',
    },
    {
      source: RedoMarket,
      title: 'Redo Market',
    },
    {
      source: SunsetMarket,
      title: 'Sunnset Market',
    },
    {
      source: TustinDinoDash,
      title: 'Tustin Dino Dash',
    },
    {
      source: TustinPonyBaseball,
      title: 'Tustin Pony Baseball',
    },
    {
      source: ChargersFootball,
      title: 'Chargers Football',
    },
    {
      source: GreatParkIce,
      title: 'Great Park Ice',
    },
    {
      source: OCRiptide,
      title: 'OC Riptide',
    },
    {
      source: THFootball,
      title: 'TH Football',
    },
    {
      source: Powerstone,
      title: 'Powerstone',
    }
  ]

  return (
    <div className={styles.carousel}>
      <div className={styles.logosWrap}>
        <div className={styles.logos}>
          {logos.map((logo, i) => (
            <Image
              key={`logo-${i}`}
              src={logo.source}
              alt={logo.title}
              loading="lazy"
            />
          ))}
          {logos.map((logo, i) => (
            <Image
              key={`logo-${i}-2x`}
              src={logo.source}
              alt={logo.title}
              loading="lazy"
            />
          ))}
        </div>
      </div>
    </div>
  )
}
